export default "__VITE_ASSET__173dd04a__"